import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, ArrowRight } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <div className="pt-24 pb-16 min-h-screen flex items-center">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <p className="text-synth-400 font-display font-semibold mb-4">404</p>
          <h1 className="text-4xl md:text-5xl font-display font-bold text-void-50 mb-4">
            Page not found
          </h1>
          <p className="text-xl text-void-400 mb-10">
            That page doesn't exist, or the link that brought you here is out of date.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-synth-600 hover:bg-synth-500 text-white font-medium transition-colors"
            >
              <Home className="w-4 h-4" />
              Back to home
            </Link>
            <Link
              to="/support/contact"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-void-800/50 hover:bg-void-700/50 border border-void-700/50 text-void-200 font-medium transition-colors"
            >
              Contact support <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
